import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
export var postOTPSendEmailMutation = {
  query: function query(data) {
    return {
      url: Endpoints.SEND_OTP_EMAIL_REQUEST,
      method: 'post',
      body: {
        data: data
      }
    };
  },
  keepUnusedDataFor: 0,
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
      var queryFulfilled;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              handleQueryLoggerEvents(_context.t0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postOTPAuthenticateMutation = {
  query: function query(data) {
    return {
      url: Endpoints.AUTHENTICATE_OTP,
      method: 'post',
      body: {
        data: data
      }
    };
  },
  keepUnusedDataFor: 0,
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, _ref2) {
      var queryFulfilled, _yield$queryFulfilled, _data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              queryFulfilled = _ref2.queryFulfilled;
              _context2.prev = 1;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context2.sent;
              _data = _yield$queryFulfilled.data;
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              handleQueryLoggerEvents(_context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }));

    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};